import { SkeletonCard } from "./SkeletonCard";

export default function PageLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="w-full max-w-xl">
        <SkeletonCard />
      </div>
    </div>
  );
}